import { PdInputUrl } from "./pd-input-url/PdInputUrl.js";
//#region src/pd-input-url/pd-input-url.ts
var tag = "pd-input-url";
if (!customElements.get(tag)) customElements.define(tag, PdInputUrl);
//#endregion
export { PdInputUrl };
